import useSWR from 'swr';

/**
 * A hook to fetch data from DC BE api
 * @param fetcher The DC BE client API fetch method
 * @param options The options for the API endpoint
 * @param keys Keys on which the data needs to be fetched
 * @returns useSWR response object
 *
 * @example
 * import { getApiLabelsByLabelPricingDynamic } from "@dc-be/client";
 * const {data, isLoading, error} = usePublicDCBE(getApiLabelsByLabelPricingDynamic, {
 *   query: {
 *     startDate: '2024-08-01',
 *     endDate: '2024-08-01',
 *     aggregation: 'hourly',
 *   }
 * })
 */

export default function usePublicDCBE<T, W>(
  fetcher: (options: T) => Promise<W>,
  options: T,
  keys: string[] | null = [],
) {
  return useSWR<W>(
    () => {
      if (keys === null) return null;
      return keys.join();
    },
    keys === null ? null : () => fetcher(options),
  );
}
